import {action, makeAutoObservable} from "mobx";
import Seller from "../../../entities/Seller";
import {SellerService} from "../../../service/SellerService";
import CommonStore from "../../../stores/CommonStore";


class RemoveSellerStore {

    public seller: Seller;
    public loading: boolean;
    public commonStore: CommonStore;


    constructor(commonStore: CommonStore, seller: Seller) {
        this.seller = seller;
        this.loading = false;
        this.commonStore = commonStore;
        makeAutoObservable(this);
    }


    @action
    public async remove() {
        const response = await SellerService.remove(this.seller);
        this.commonStore.processErrors(response);
        return response.success;
    }
}

export default RemoveSellerStore;